import { useSelector } from "react-redux"

const useAuth = () => {
  let accessToken = localStorage.getItem('access_token')
  let expirationTime = localStorage.getItem('token_expiration')

  let {currentUser} = useSelector((state) => state.auth)
  // `auth.currentUser` is only populated on login / verifyToken. After a plain
  // page refresh the app fetches the profile (getProfileUser) but not
  // verifyToken, so currentUser stays {} and `userName` came back empty — which
  // broke anything using it as the mail sender (e.g. Release Contract/Addendum
  // `from`, giving `Sender (from) email not found for: ""`). Fall back to the
  // profile user, which is loaded on every authenticated app start.
  const profileData = useSelector((state) => state.profile_user?.data)
  let userName = ''

  if (currentUser && Object.keys(currentUser).length > 0)
    userName = currentUser.name
  else if (profileData?.name)
    userName = profileData.name

  // //token expired then call Logout route
  // if (accessToken && (expirationDate < Date.now() / 1000))
  // {
  //   localStorage.clear()
  //   //refirect to logout
  //   history.push("/authentication/login")
  // }
  const now = Math.floor(Date.now() / 1000);

  let isAuthenticated = (accessToken && (expirationTime > now)) || false
  return {isAuthenticated, userName}
}

export default useAuth